export default "__VITE_ASSET__B82XYMp5__"